var React = require('react');

function FlagGh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M512 200.093H0V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828L512 200.093z","fill":"#ff4b55","key":0}),React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V311.909h512v102.988a8.828 8.828 0 01-8.828 8.828z","fill":"#73af00","key":1}),React.createElement("path",{"fill":"#ffe15a","d":"M0 200.091h512v111.81H0z","key":2}),React.createElement("path",{"d":"M259.722 213.91l9.213 27.623 29.118.226c3.769.029 5.333 4.84 2.301 7.08l-23.424 17.298 8.783 27.763c1.138 3.594-2.955 6.568-6.023 4.375L256 281.341l-23.69 16.932c-3.066 2.193-7.159-.781-6.023-4.375l8.783-27.763-23.424-17.298c-3.032-2.24-1.47-7.05 2.301-7.08l29.118-.226 9.213-27.623c1.193-3.574 6.251-3.574 7.444.002z","fill":"#464655","key":3})]);
}

FlagGh.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagGh;

FlagGh.default = FlagGh;
